import { render, staticRenderFns } from "./MultiLevelDropdownV2.vue?vue&type=template&id=38c577c0&scoped=true&"
import script from "./MultiLevelDropdownV2.vue?vue&type=script&lang=ts&"
export * from "./MultiLevelDropdownV2.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLevelDropdownV2.vue?vue&type=style&index=0&id=38c577c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c577c0",
  null
  
)

export default component.exports